// function to converting date in DD/MM/YYY Formate
export function convertDateDDMMYYYY(dateString) {
  if (!dateString) {
    return dateString;
  }
   // Extract only the date part (before 'T')
   const datePart = dateString.split('T')[0];
  // Extract the date parts
  const [year, month, day] = datePart.split('-');

  // Check if the date is valid
  const date = new Date(`${year}-${month}-${day}`);

  // // Check if the date is valid (i.e., if the Date object conversion was successful)
  // if (date.getFullYear() != year || date.getMonth() + 1 != month || date.getDate() != day) {
  //   return dateString;
  // }

  // Return the formatted date
  return `${day}/${month}/${year}`;
}


